import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import type { StepStats } from '@/run-stage/utils/stepFlattener';

interface StepStatsRowProps {
  stats: StepStats;
}

export const StepStatsRow: React.FC<StepStatsRowProps> = ({ stats }) => {
  return (
    <Box sx={{ px: 2, py: 0.5, borderBottom: '1px solid', borderColor: 'divider', backgroundColor: 'background.paper' }}>
      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
        <Chip label={`Total: ${stats.total}`} size="small" variant="outlined" />
        <Chip label={`Completed: ${stats.completed}`} size="small" color="success" variant="outlined" />
        <Chip label={`Pending: ${stats.pending}`} size="small" variant="outlined" />
        <Chip label={`Skipped: ${stats.skipped}`} size="small" color="warning" variant="outlined" />
        {stats.repeated > 0 && (
          <Chip label={`Repeated: ${stats.repeated}`} size="small" color="info" variant="outlined" />
        )}
        {stats.inProgress > 0 && (
          <Chip label={`In Progress: ${stats.inProgress}`} size="small" color="primary" variant="outlined" />
        )}
      </Stack>
    </Box>
  );
};
